import React from 'react'
import PropTypes from 'prop-types'
import MobileInput from 'react-telephone-input'
import 'less/controls/field.less'

const checkboxOrRadio = ({ label,isCheckBox, ...props }) => (
  <label>
    <input {...props} />
    {label &&  (label === "Allow Contact By Email" || isCheckBox =='true' ) ?
      <>
        <span className="input-mask" />
        <span className="label-text">{label}</span>
      </>
      :
      <div className="input-container">
        <span className="input-mask" />
        <span className="label-text">{label}</span>
      </div>
    }
  </label>
)

const errorIcon = errors => (
  <a className="field-error-icon">
    {errors.map((error, i) => <span className="field-error" key={i}>{error}</span>)}
  </a>
)

const validated = valid => (
  <a className="field-validated-icon">
    {valid.map((isValid, i) => <span className="field-valid" key={i}>{isValid}</span>)}
  </a>
)

const conditionallyShowErrors = errors => Boolean(errors && errors.length) && errorIcon(errors)
const conditionallyShowValidation = valid => Boolean(valid) && validated(valid)

const typeTemplates = {
  radio: checkboxOrRadio,
  checkbox: checkboxOrRadio,
  textarea: ({label, ...props}) => (
    <label>
      <span>{label}</span>
      <textarea {...props} />
    </label>
  ),
  select: ({label, options, ...props}) => (
    <label>
      <span>{label}</span>
      <select {...props}>
        {options.map(({display, ...props}, i) => <option key={i} {...props}>{display}</option>)}
      </select>
    </label>
  ),
  basic: ({label, errors,valid, ...props}) => (
    <label className="basic-label">
      <span>{label}</span>
      <span className="input-container">
        <input className="basic-input" {...props} />
        {conditionallyShowErrors(errors)}
        {conditionallyShowValidation(valid)}
      </span>
    </label>
  ),
  'i18n-mobile': ({label, onChange, errors,valid, ...props}) => (
    <span>
      <label className="sibling-label">{label}</label>
      <span className="input-container">
        <MobileInput
          flagsImagePath="/images/flags.png"
          preferredCountries={['us']}
          onChange={(formattedInput) => onChange(formattedInput.replace(/[\s()-]/g, ''))}
          {...props}
        />
        {conditionallyShowErrors(errors)}
        {conditionallyShowValidation(valid)}
      </span>
    </span>
  ),
}

const Field = props => (
  <div className={`form-field-row type-${props.type || ''}`}>
    {props.children || (typeTemplates[props.type] || typeTemplates.basic)(props)}
  </div>
)

Field.propTypes = {
  type: PropTypes.string,
  isCheckBox: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  placeholder: PropTypes.string,

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
  ]),

  onChange: PropTypes.func,
}

export default Field
